import { TraitId } from '@cibo/core'
import { Markdown } from '@cibo/ui'
import { CircularProgress } from '@mui/material'
import { JSXElementConstructor, PropsWithChildren } from 'react'
import { useTraitContent } from './useTraitContent'

type TraitContentProps = {
  traitId: TraitId
  ParentComponent?: JSXElementConstructor<PropsWithChildren>
}

export const TraitContent = ({ traitId, ParentComponent }: TraitContentProps) => {
  const traitContent = useTraitContent(traitId)

  if (traitContent.isFetching) return <CircularProgress />

  if (ParentComponent) {
    return traitContent.data ? (
      <ParentComponent>
        <Markdown>{traitContent.data}</Markdown>
      </ParentComponent>
    ) : null
  }

  return traitContent.data ? <Markdown>{traitContent.data}</Markdown> : null
}
